import { render, staticRenderFns } from "./CardReports.vue?vue&type=template&id=2419bf54&scoped=true&"
import script from "./CardReports.vue?vue&type=script&lang=js&"
export * from "./CardReports.vue?vue&type=script&lang=js&"
import style0 from "./CardReports.vue?vue&type=style&index=0&id=2419bf54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2419bf54",
  null
  
)

export default component.exports